import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  AspectRatio,
  Image,
} from '@chakra-ui/react';
import { IconLinks } from 'features/common/utils/icons';

export type XmCloudTrialModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryButtonClick: () => void;
};

const VIDEO_URL = 'https://www.youtube.com/embed/ak6H4M6wNB0?si=CBBW7L7F8K4XJXuV&amp&start=1&autoplay=1';

const XmCloudTrialModal = ({
  isOpen,
  onClose,
  onPrimaryButtonClick,
}: XmCloudTrialModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered size="4xl">
    <ModalOverlay />
    <ModalContent maxW='896px' w='90vw'>
      <ModalHeader px={6} py={4}>
        <Text fontSize='xl' fontWeight='semibold'>
          Get started with SitecoreAI
        </Text>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody px={6} pt={2} pb={4}>
        <AspectRatio ratio={16 / 9}>
          <Box
            as="iframe"
            src={VIDEO_URL}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            borderRadius="md"
            w="100%"
            h="100%"
          />
        </AspectRatio>
      </ModalBody>
      <ModalFooter px={6} py={4} justifyContent="flex-end" gap={3}>
        <Button variant="ghost" onClick={onClose}>
          Close
        </Button>
        <Button 
          colorScheme='purple' 
          onClick={onPrimaryButtonClick}
          leftIcon={
            <Image
              src={IconLinks.sitecoreAILogo}
              w="16px"
              h="16px"
              alt="Sitecore AI"
              filter="brightness(0) invert(1)"
            />
          }
        >
          SitecoreAI
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default XmCloudTrialModal;
